/**
 * @file   remote-data-set.js - Contains the class definition for (array of) URI's.
 * 
 * @see    {@link https://kingsds.atlassian.net/browse/DCP-1478|Jira Issue}
 * @author Bryan Hoang <bryan@kingsds.network>
 *         Nazila Akhavan <nazila@kingsds.network>
 * @date   Oct. 2020, Sep. 2021
 * 
 */
const { DCPError } = require('dcp/common/dcp-error')
const { DcpURL } = require('dcp/common/dcp-url');
const debugging = require('dcp/debugging').scope('dcp-client');

const debug = (...args) => {
  if (debugging('compute:remote-data-set')) {
    args.unshift('dcp-client:compute:remote-data-set');
    console.debug(...args);
  }
};

/**
 * Instances of this class store URIs representing data, arguments, etc. The
 * primary purpose of this class, at this time, is to allow us to easily
 * differentiate  between Arrays of stuff and Arrays of URIs which point at
 * stuff. This job logs the contents of the URLs described by a URI, not the
 * URLs themselves:
 *
 * @example
 * const a = [ 'http://abc.com/1.json', 'http://def.com/two.json' ];
 * const { RemoteDataSet } = require('dcp/compute');
 * let b = new RemoteDataSet(...a);
 * OR( b = new RemoteDataSet(a))
 * const job = compute.for(b, function(el) { console.log(el)});
 * job.on('console', console.log);
 * await job.exec();
 */
module.exports.RemoteDataSet = function (uris)
{
  if (!Array.isArray(uris))
    uris = Array.from(arguments);
  if (!new.target)
    return new module.exports.RemoteDataSet(uris);

  this.length = uris.length;

  for (let i = 0; i < uris.length; i++)
  {
    if (typeof uris[i] === "string" && uris[i].startsWith('data:'))
      this[i] =  new URL(uris[i]);
    else if (typeof uris[i] === "string")
      this[i] = new URL(uris[i]).href;
    else if (DcpURL.isURL(uris[i]))
      this[i] = uris[i].href;
    else
      throw new DCPError(`invalid uri at position ${i + 1}: ${uris[i]}`);
  }
}

module.exports.RemoteDataSet.isRemoteDataSet = function (r)
{
  if (r instanceof module.exports.RemoteDataSet)
    return true;

  return false;
}

module.exports.RemoteDataSet.isProtoRemoteDataSetLike = function (r)
{
  if (Array.isArray(r))
  {
    for (let i = 0; i < r.length; i++)
   {
    if (!DcpURL.isURL(r[i]))
      return false;
   }
   return true;
  }

  return false;
}
 
module.exports.RemoteDataSet.prototype = new Array(); 